/**
 * useDebouncedValue — trail a changing value by `delayMs` (300ms default).
 * Used by the server-paged bank tables so a keystroke costs one request, not
 * one per character (MD-1063).
 * For Media Devoted | Created By James Alexandrov
 */

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
